// src/utils/validation.js

import { containsMaliciousContent } from "./security";

const cleanSpaces = (value) => value.replace(/\s+/g, " ").trim();

export const validateField = (name, value) => {
  value = cleanSpaces(value);

  if (!value) {
    return "This field is required.";
  }

  if (containsMaliciousContent(value)) {
    return "Malicious content detected.";
  }

  switch (name) {
    case "title":
      if (value.length < 2) return "Name must be at least 2 characters.";

      if (value.length > 50) return "Name cannot exceed 50 characters.";

      if (!/^[A-Za-z\s'-]+$/.test(value))
        return "Only letters, spaces, apostrophe and hyphen are allowed.";

      break;

    case "organization":
      if (value.length < 2) return "Organization name is too short.";

      if (value.length > 100) return "Maximum 100 characters allowed.";

      if (!/^[A-Za-z0-9\s.,&()'-]+$/.test(value))
        return "Invalid organization name.";

      break;

    case "email":
      if (value.length > 100) return "Email is too long.";

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value))
        return "Invalid email address.";

      break;

    case "phoneNumber":
      if (!/^[6-9]\d{9}$/.test(value))
        return "Enter valid 10 digit mobile number.";

      break;

    case "query":
      if (value.length < 3) return "Query is too short.";

      if (value.length > 100) return "Maximum 100 characters allowed.";

      if (!/^[A-Za-z0-9\s.,&()'-]+$/.test(value)) return "Invalid query.";

      break;

    case "city":
      if (value.length < 2) return "City is too short.";

      if (value.length > 50) return "Maximum 50 characters allowed.";

      if (!/^[A-Za-z\s'-]+$/.test(value)) return "Invalid city name.";

      break;

    case "message":
      if (value.length < 10) return "Message should be at least 10 characters.";

      if (value.length > 1000) return "Maximum 1000 characters allowed.";

      break;

    default:
      break;
  }

  return "";
};

export const validateForm = (formData) => {
  const errors = {};

  Object.keys(formData).forEach((key) => {
    const error = validateField(key, formData[key]);

    if (error) {
      errors[key] = error;
    }
  });

  return errors;
};
